var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPixCircle = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#32BCAD"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7193 11.751C12.347 11.751 12.9372 11.9955 13.3811 12.4391L15.7896 14.8481C15.9631 15.0215 16.2462 15.0222 16.4202 14.8478L18.8199 12.4479C19.2638 12.0043 19.8541 11.7598 20.4819 11.7598H20.7709L17.7229 8.71192C16.7737 7.76269 15.2348 7.76269 14.2856 8.71192L11.2465 11.751H11.7193ZM20.482 20.2402C19.8542 20.2402 19.2639 19.9957 18.82 19.552L16.4204 17.1524C16.2519 16.9834 15.9583 16.9839 15.7898 17.1524L13.3813 19.5608C12.9374 20.0045 12.3471 20.2488 11.7194 20.2488H11.2465L14.2857 23.2882C15.2349 24.2373 16.7739 24.2373 17.723 23.2882L20.771 20.2402H20.482ZM21.4453 12.4403L23.2871 14.2822C24.2364 15.2313 24.2364 16.7703 23.2871 17.7195L21.4453 19.5613C21.4047 19.5451 21.3609 19.535 21.3145 19.535H20.4771C20.0441 19.535 19.6203 19.3595 19.3144 19.0532L16.9148 16.6538C16.4798 16.2184 15.7211 16.2185 15.2857 16.6535L12.8772 19.0621C12.5712 19.3681 12.1474 19.5437 11.7145 19.5437H10.6847C10.6409 19.5437 10.5997 19.5541 10.561 19.5687L8.7118 17.7195C7.76257 16.7703 7.76257 15.2313 8.7118 14.2822L10.5611 12.4329C10.5998 12.4475 10.6409 12.458 10.6847 12.458H11.7145C12.1474 12.458 12.5712 12.6335 12.8772 12.9396L15.2859 15.3483C15.5104 15.5726 15.8052 15.685 16.1003 15.685C16.3951 15.685 16.6902 15.5726 16.9146 15.3481L19.3144 12.9484C19.6203 12.6422 20.0441 12.4666 20.4771 12.4666H21.3145C21.3608 12.4666 21.4047 12.4566 21.4453 12.4403Z",
    fill: "white"
  }));
};
export default SvgPixCircle;